/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_MY_ORGANIZATION = gql`
  query GetMyOrgProfile {
    getMyOrgProfile {
      name
      primaryContactNo
      fullAddress
      email
      description
      country
      address {
        addressLine1
        addressLine2
        addressLine3
        city
        country
        state
        zipCode
      }
      logo
      socialLinks
      website
    }
  }
`;
